<template>
        
        <quill-editor
            v-model="detail"
            ref="myQuillEditor"
            :options="editorOption"
            @change="onEditorChange($event)"
            @focus="onEditorFocus($event)"
            >
           </quill-editor>

</template>

<script>
    import { quillEditor } from 'vue-quill-editor'
    import 'quill/dist/quill.core.css';
    import 'quill/dist/quill.snow.css';
    import 'quill/dist/quill.bubble.css';
    import { uploadImg } from "network/LPersonal.js";

    const tapOption = [
        ['bold', 'italic', 'underline', 'strike'],
        [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
        [{ 'size': ['small', false, 'large', 'huge'] }],
        [{ 'color': [] }, { 'background': [] }],
        ['blockquote', 'code-block'],
        [{ 'list': 'ordered' }, { 'list': 'bullet' }],
        // [{ 'script': 'sub' }, { 'script': 'super' }],
        [{ 'indent': '-1' }, { 'indent': '+1' }],
        [{ 'align': [] }],
        [{ 'direction': 'rtl' }],
        // [{ 'font': [] }],
        ['clean'],
        ['link', 'image']
    ]

    export default {
        name: 'quill',
        components: {
            'quillEditor': quillEditor
        },
        props: {
            content: {
                default: null
            },
            disbld:{
                type: Boolean,
                default: false
            }
        },
        data () {
            return {
                Quill: null,
                currentValue: '',
                detail: '',
                editorOption: {
                    placeholder: '暂无数据',
                    theme: 'snow',
                    bounds: document.body,
                    debug: 'warn',
                    modules: {
                        toolbar: {
                            container: tapOption,
                            handlers: {
                            'image': function (value) {
                                let self = this;
                                let element = document.createElement('input')
                                element.type = 'file'
                                element.setAttribute("id", "editorFile");
                                document.body.appendChild(element)
                                element.click();
                                element.addEventListener('change',function(file){
                                    let formData = file.target.files[0];
                                    // let extensionName = formData.name.substr(formData.name.indexOf('.')) // 文件扩展名
                                    // let name = res+extensionName
                                    // formData.append('file',file.target.files[0]);
                                    let params = new FormData();
                                    params.append('img',formData)
                                    // console.log(params)
                                    uploadImg(params).then((res)=>{
                                        // console.log(self.quill)
                                        let length = self.quill.getSelection(true).index;
                                        // console.log(length);
                                        let uploadUrl = res.data.data.imageUrl;
                                        self.quill.insertEmbed(length, 'image', uploadUrl);
                                        self.quill.setSelection(length + 1)
                                    }).catch((err) => {
                                        console.log(err)
                                    })
                                })
                            },
                        }
                    },
                    
                }
            }
            }
        },
        
        computed: {
            classes () {
                return [
                    {
                        'i-quill-no-border': !this.border
                    }
                ];
            },
            styles () {
                let style = {};
                if (this.minHeight) {
                    style.minHeight = `${this.minHeight}px`;
                }
                if (this.height) {
                    style.height = `${this.height}px`;
                }
                return style;
            },
            getValue(val){
                 this.detail = val.content;
                 return this.detail
            },
        },
        watch: {
            content(val) {
                this.getValue;
            }
        },
        methods: {
            onEditorFocus(event) { 
                if(this.disbld){
                    event.enable(false);
                }
            }, // 获得焦点事件
            
            getValues(val){
                 this.detail = val;
                 return this.detail
            },
          
             onEditorChange(){//内容改变事件
                this.$emit('handlerEditor',{content: this.detail})
            },
        },
        activated () {
        },
        mounted(){
            this.getValues(this.content)
            this.$refs.myQuillEditor.quill.enable(false)
        },
    }
</script>
<style lang="less">
    .quill-editor{
        border: none;
        .ql-toolbar.ql-snow{
            display: none;
        }
        .ql-container.ql-snow{
            border: none;
        }
    }

</style>
